function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { makeDraggable } from './draggable.js';
import EventEmitter from './event-emitter.js';

var Renderer = /*#__PURE__*/function (_EventEmitter) {
  _inherits(Renderer, _EventEmitter);

  var _super = _createSuper(Renderer);

  function Renderer(options, audioElement) {
    var _this;

    _classCallCheck(this, Renderer);

    _this = _super.call(this);
    _this.timeouts = [];
    _this.isScrolling = false;
    _this.audioData = null;
    _this.resizeObserver = null;
    _this.isDragging = false;
    _this.options = options;
    var parent;

    if (typeof options.container === 'string') {
      parent = document.querySelector(options.container);
    } else if (options.container instanceof HTMLElement) {
      parent = options.container;
    }

    if (!parent) {
      throw new Error('Container not found');
    }

    _this.parent = parent;

    var _this$initHtml = _this.initHtml(),
        _this$initHtml2 = _slicedToArray(_this$initHtml, 2),
        div = _this$initHtml2[0],
        shadow = _this$initHtml2[1];

    parent.appendChild(div);
    _this.container = div;
    _this.scrollContainer = shadow.querySelector('.scroll');
    _this.wrapper = shadow.querySelector('.wrapper');
    _this.canvasWrapper = shadow.querySelector('.canvases');
    _this.progressWrapper = shadow.querySelector('.progress');
    _this.cursor = shadow.querySelector('.cursor');

    if (audioElement) {
      shadow.appendChild(audioElement);
    }

    _this.initEvents();

    return _this;
  }

  _createClass(Renderer, [{
    key: "initEvents",
    value: function initEvents() {
      var _this2 = this;

      // Add a click listener
      this.wrapper.addEventListener('click', function (e) {
        var rect = _this2.wrapper.getBoundingClientRect();

        var x = e.clientX - rect.left;
        var relativeX = x / rect.width;

        _this2.emit('click', relativeX);
      }); // Drag

      this.initDrag(); // Add a scroll listener

      this.scrollContainer.addEventListener('scroll', function () {
        var _this2$scrollContaine = _this2.scrollContainer,
            scrollLeft = _this2$scrollContaine.scrollLeft,
            scrollWidth = _this2$scrollContaine.scrollWidth,
            clientWidth = _this2$scrollContaine.clientWidth;
        var startX = scrollLeft / scrollWidth;
        var endX = (scrollLeft + clientWidth) / scrollWidth;

        _this2.emit('scroll', startX, endX);
      }); // Re-render the waveform on container resize

      var delay = this.createDelay(100);
      this.resizeObserver = new ResizeObserver(function () {
        delay(function () {
          return _this2.reRender();
        });
      });
      this.resizeObserver.observe(this.scrollContainer);
    }
  }, {
    key: "initDrag",
    value: function initDrag() {
      var _this3 = this;

      makeDraggable(this.wrapper, // On drag
      function (_, __, x) {
        _this3.emit('drag', Math.max(0, Math.min(1, x / _this3.wrapper.clientWidth)));
      }, // On start drag
      function () {
        return _this3.isDragging = true;
      }, // On end drag
      function () {
        return _this3.isDragging = false;
      });
    }
  }, {
    key: "getHeight",
    value: function getHeight() {
      var defaultHeight = 128;
      if (this.options.height == null) return defaultHeight;
      if (!isNaN(Number(this.options.height))) return Number(this.options.height);
      if (this.options.height === 'auto') return this.parent.clientHeight || defaultHeight;
      return defaultHeight;
    }
  }, {
    key: "initHtml",
    value: function initHtml() {
      var div = document.createElement('div');
      var shadow = div.attachShadow({
        mode: 'open'
      });
      shadow.innerHTML = "\n      <style>\n        :host {\n          user-select: none;\n        }\n        :host audio {\n          display: block;\n          width: 100%;\n        }\n        :host .scroll {\n          overflow-x: auto;\n          overflow-y: hidden;\n          width: 100%;\n          position: relative;\n          touch-action: none;\n        }\n        :host .noScrollbar {\n          scrollbar-color: transparent;\n          scrollbar-width: none;\n        }\n        :host .noScrollbar::-webkit-scrollbar {\n          display: none;\n          -webkit-appearance: none;\n        }\n        :host .wrapper {\n          position: relative;\n          overflow: visible;\n          z-index: 2;\n        }\n        :host .canvases {\n          min-height: ".concat(this.getHeight(), "px;\n        }\n        :host .canvases > div {\n          position: relative;\n        }\n        :host canvas {\n          display: block;\n          position: absolute;\n          top: 0;\n          image-rendering: pixelated;\n        }\n        :host .progress {\n          pointer-events: none;\n          position: absolute;\n          z-index: 2;\n          top: 0;\n          left: 0;\n          width: 0;\n          height: 100%;\n          overflow: hidden;\n        }\n        :host .progress > div {\n          position: relative;\n        }\n        :host .cursor {\n          pointer-events: none;\n          position: absolute;\n          z-index: 5;\n          top: 0;\n          left: 0;\n          height: 100%;\n          border-radius: 2px;\n        }\n      </style>\n\n      <div class=\"scroll\" part=\"scroll\">\n        <div class=\"wrapper\">\n          <div class=\"canvases\"></div>\n          <div class=\"progress\" part=\"progress\"></div>\n          <div class=\"cursor\" part=\"cursor\"></div>\n        </div>\n      </div>\n    ");
      return [div, shadow];
    }
  }, {
    key: "setOptions",
    value: function setOptions(options) {
      this.options = options; // Re-render the waveform

      this.reRender();
    }
  }, {
    key: "getWrapper",
    value: function getWrapper() {
      return this.wrapper;
    }
  }, {
    key: "getScroll",
    value: function getScroll() {
      return this.scrollContainer.scrollLeft;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _a;

      this.container.remove();
      (_a = this.resizeObserver) === null || _a === void 0 ? void 0 : _a.disconnect();
    }
  }, {
    key: "createDelay",
    value: function createDelay() {
      var delayMs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
      var context = {};
      this.timeouts.push(context);
      return function (callback) {
        context.timeout && clearTimeout(context.timeout);
        context.timeout = setTimeout(callback, delayMs);
      };
    } // Convert array of color values to linear gradient

  }, {
    key: "convertColorValues",
    value: function convertColorValues(color) {
      if (!Array.isArray(color)) return color || '';
      if (color.length < 2) return color[0] || '';
      var canvasElement = document.createElement('canvas');
      var ctx = canvasElement.getContext('2d');
      var gradient = ctx.createLinearGradient(0, 0, 0, canvasElement.height);
      var colorStopPercentage = 1 / (color.length - 1);
      color.forEach(function (color, index) {
        var offset = index * colorStopPercentage;
        gradient.addColorStop(offset, color);
      });
      return gradient;
    }
  }, {
    key: "renderBars",
    value: function renderBars(channelData, options, ctx) {
      ctx.fillStyle = this.convertColorValues(options.waveColor); // Custom rendering function

      if (options.renderFunction) {
        options.renderFunction(channelData, ctx);
        return;
      }

      var topChannel = channelData[0];
      var bottomChannel = channelData[1] || channelData[0];
      var length = topChannel.length;
      var pixelRatio = window.devicePixelRatio || 1;
      var _ctx$canvas = ctx.canvas,
          width = _ctx$canvas.width,
          height = _ctx$canvas.height;
      var halfHeight = height / 2;
      var barHeight = options.barHeight || 1;
      var barWidth = options.barWidth ? options.barWidth * pixelRatio : 1;
      var barGap = options.barGap ? options.barGap * pixelRatio : options.barWidth ? barWidth / 2 : 0;
      var barRadius = options.barRadius || 0;
      var barIndexScale = width / (barWidth + barGap) / length;
      var max = 1;

      if (options.normalize) {
        max = 0;

        for (var i = 0; i < length; i++) {
          var value = Math.abs(topChannel[i]);
          if (value > max) max = value;
        }
      }

      var vScale = halfHeight / max * barHeight;
      var rectFn = barRadius && 'roundRect' in ctx ? 'roundRect' : 'rect';
      ctx.beginPath();
      var prevX = 0;
      var maxTop = 0;
      var maxBottom = 0;

      for (var _i2 = 0; _i2 <= length; _i2++) {
        var x = Math.round(_i2 * barIndexScale);

        if (x > prevX) {
          var leftBarHeight = Math.round(maxTop * vScale);
          var rightBarHeight = Math.round(maxBottom * vScale);

          var _barHeight = leftBarHeight + rightBarHeight || 1; // Vertical alignment


          var y = halfHeight - leftBarHeight;
          if (options.barAlign === 'top') y = 0;else if (options.barAlign === 'bottom') y = height - _barHeight;
          ctx[rectFn](prevX * (barWidth + barGap), y, barWidth, _barHeight, barRadius);
          prevX = x;
          maxTop = 0;
          maxBottom = 0;
        }

        var magnitudeTop = Math.abs(topChannel[_i2] || 0);
        var magnitudeBottom = Math.abs(bottomChannel[_i2] || 0);
        if (magnitudeTop > maxTop) maxTop = magnitudeTop;
        if (magnitudeBottom > maxBottom) maxBottom = magnitudeBottom;
      }

      ctx.fill();
      ctx.closePath();
    }
  }, {
    key: "renderSingleCanvas",
    value: function renderSingleCanvas(channelData, options, width, height, start, end, canvasContainer, progressContainer) {
      var pixelRatio = window.devicePixelRatio || 1;
      var canvas = document.createElement('canvas');
      var length = channelData[0].length;
      canvas.width = Math.round(width * (end - start) / length);
      canvas.height = height * pixelRatio;
      canvas.style.width = "".concat(Math.floor(canvas.width / pixelRatio), "px");
      canvas.style.height = "".concat(height, "px");
      canvas.style.left = "".concat(Math.floor(start * width / pixelRatio / length), "px");
      canvasContainer.appendChild(canvas);
      var ctx = canvas.getContext('2d');
      this.renderBars(channelData.map(function (channel) {
        return channel.slice(start, end);
      }), options, ctx); // Draw a progress canvas

      var progressCanvas = canvas.cloneNode();
      progressContainer.appendChild(progressCanvas);
      var progressCtx = progressCanvas.getContext('2d');

      if (canvas.width > 0 && canvas.height > 0) {
        progressCtx.drawImage(canvas, 0, 0);
      } // Set the composition method to draw only where the waveform is drawn


      progressCtx.globalCompositeOperation = 'source-in';
      progressCtx.fillStyle = this.convertColorValues(options.progressColor); // This rectangle acts as a mask thanks to the composition method

      progressCtx.fillRect(0, 0, canvas.width, canvas.height);
    }
  }, {
    key: "renderWaveform",
    value: function renderWaveform(channelData, options, width) {
      var _this4 = this;

      // A container for canvases
      var canvasContainer = document.createElement('div');
      var height = this.getHeight();
      canvasContainer.style.height = "".concat(height, "px");
      this.canvasWrapper.style.minHeight = "".concat(height, "px");
      this.canvasWrapper.appendChild(canvasContainer); // A container for progress canvases

      var progressContainer = canvasContainer.cloneNode();
      this.progressWrapper.appendChild(progressContainer); // Determine the currently visible part of the waveform

      var _this$scrollContainer = this.scrollContainer,
          scrollLeft = _this$scrollContainer.scrollLeft,
          scrollWidth = _this$scrollContainer.scrollWidth,
          clientWidth = _this$scrollContainer.clientWidth;
      var len = channelData[0].length;
      var scale = len / scrollWidth;
      var viewportWidth = Math.min(Renderer.MAX_CANVAS_WIDTH, clientWidth); // Adjust width to avoid gaps between canvases when using bars

      if (options.barWidth || options.barGap) {
        var barWidth = options.barWidth || 0.5;
        var barGap = options.barGap || barWidth / 2;
        var totalBarWidth = barWidth + barGap;

        if (viewportWidth % totalBarWidth !== 0) {
          viewportWidth = Math.floor(viewportWidth / totalBarWidth) * totalBarWidth;
        }
      }

      var start = Math.floor(Math.abs(scrollLeft) * scale);
      var end = Math.floor(start + viewportWidth * scale);
      var viewportLen = end - start; // Draw a portion of the waveform from start peak to end peak

      var draw = function draw(start, end) {
        _this4.renderSingleCanvas(channelData, options, width, height, Math.max(0, start), Math.min(end, len), canvasContainer, progressContainer);
      }; // Draw the waveform in viewport chunks, each with a delay


      var headDelay = this.createDelay();
      var tailDelay = this.createDelay();

      var renderHead = function renderHead(fromIndex, toIndex) {
        draw(fromIndex, toIndex);

        if (fromIndex > 0) {
          headDelay(function () {
            renderHead(fromIndex - viewportLen, toIndex - viewportLen);
          });
        }
      };

      var renderTail = function renderTail(fromIndex, toIndex) {
        draw(fromIndex, toIndex);

        if (toIndex < len) {
          tailDelay(function () {
            renderTail(fromIndex + viewportLen, toIndex + viewportLen);
          });
        }
      };

      renderHead(start, end);

      if (end < len) {
        renderTail(end, end + viewportLen);
      }
    }
  }, {
    key: "render",
    value: function render(audioData) {
      // Clear previous timeouts
      this.timeouts.forEach(function (context) {
        return context.timeout && clearTimeout(context.timeout);
      });
      this.timeouts = []; // Clear the canvases

      this.canvasWrapper.innerHTML = '';
      this.progressWrapper.innerHTML = '';
      this.wrapper.style.width = ''; // Determine the width of the waveform

      var pixelRatio = window.devicePixelRatio || 1;
      var parentWidth = this.scrollContainer.clientWidth;
      var scrollWidth = Math.ceil(audioData.duration * (this.options.minPxPerSec || 0)); // Whether the container should scroll

      this.isScrolling = scrollWidth > parentWidth;
      var useParentWidth = this.options.fillParent && !this.isScrolling; // Width of the waveform in pixels

      var width = (useParentWidth ? parentWidth : scrollWidth) * pixelRatio; // Set the width of the wrapper

      this.wrapper.style.width = useParentWidth ? '100%' : "".concat(scrollWidth, "px"); // Set additional styles

      this.scrollContainer.style.overflowX = this.isScrolling ? 'auto' : 'hidden';
      this.scrollContainer.classList.toggle('noScrollbar', !!this.options.hideScrollbar);
      this.cursor.style.backgroundColor = "".concat(this.options.cursorColor || this.options.progressColor);
      this.cursor.style.width = "".concat(this.options.cursorWidth, "px"); // Render the waveform

      if (this.options.splitChannels) {
        // Render a waveform for each channel
        for (var i = 0; i < audioData.numberOfChannels; i++) {
          var options = Object.assign(Object.assign({}, this.options), this.options.splitChannels[i]);
          this.renderWaveform([audioData.getChannelData(i)], options, width);
        }
      } else {
        // Render a single waveform for the first two channels (left and right)
        var channels = [audioData.getChannelData(0)];
        if (audioData.numberOfChannels > 1) channels.push(audioData.getChannelData(1));
        this.renderWaveform(channels, this.options, width);
      }

      this.audioData = audioData;
      this.emit('render');
    }
  }, {
    key: "reRender",
    value: function reRender() {
      // Return if the waveform has not been rendered yet
      if (!this.audioData) return; // Remember the current cursor position

      var oldCursorPosition = this.progressWrapper.clientWidth; // Set the new zoom level and re-render the waveform

      this.render(this.audioData); // Adjust the scroll position so that the cursor stays in the same place

      var newCursortPosition = this.progressWrapper.clientWidth;
      this.scrollContainer.scrollLeft += newCursortPosition - oldCursorPosition;
    }
  }, {
    key: "zoom",
    value: function zoom(minPxPerSec) {
      this.options.minPxPerSec = minPxPerSec;
      this.reRender();
    }
  }, {
    key: "scrollIntoView",
    value: function scrollIntoView(progress) {
      var isPlaying = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$scrollContainer2 = this.scrollContainer,
          clientWidth = _this$scrollContainer2.clientWidth,
          scrollLeft = _this$scrollContainer2.scrollLeft,
          scrollWidth = _this$scrollContainer2.scrollWidth;
      var progressWidth = scrollWidth * progress;
      var center = clientWidth / 2;
      var minScroll = isPlaying && this.options.autoCenter && !this.isDragging ? center : clientWidth;

      if (progressWidth > scrollLeft + minScroll || progressWidth < scrollLeft) {
        // Scroll to the center
        if (this.options.autoCenter && !this.isDragging) {
          // If the cursor is in viewport but not centered, scroll to the center slowly
          var minDiff = center / 20;

          if (progressWidth - (scrollLeft + center) >= minDiff && progressWidth < scrollLeft + clientWidth) {
            this.scrollContainer.scrollLeft += minDiff;
          } else {
            // Otherwise, scroll to the center immediately
            this.scrollContainer.scrollLeft = progressWidth - center;
          }
        } else if (this.isDragging) {
          // Scroll just a little bit to allow for some space between the cursor and the edge
          var gap = 10;
          this.scrollContainer.scrollLeft = progressWidth < scrollLeft ? progressWidth - gap : progressWidth - clientWidth + gap;
        } else {
          // Scroll to the beginning
          this.scrollContainer.scrollLeft = progressWidth;
        }
      } // Emit the scroll event


      {
        var _scrollLeft = this.scrollContainer.scrollLeft;
        var startX = _scrollLeft / scrollWidth;
        var endX = (_scrollLeft + clientWidth) / scrollWidth;
        this.emit('scroll', startX, endX);
      }
    }
  }, {
    key: "renderProgress",
    value: function renderProgress(progress, isPlaying) {
      if (isNaN(progress)) return;
      this.progressWrapper.style.width = "".concat(progress * 100, "%");
      this.cursor.style.left = "".concat(progress * 100, "%");
      this.cursor.style.marginLeft = Math.round(progress * 100) === 100 ? "-".concat(this.options.cursorWidth, "px") : '';

      if (this.isScrolling && this.options.autoScroll) {
        this.scrollIntoView(progress, isPlaying);
      }
    }
  }]);

  return Renderer;
}(EventEmitter);

Renderer.MAX_CANVAS_WIDTH = 4000;
export default Renderer;